export default {
	close: '關閉'
};
